var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23223 16.8815C0.255922 17.8578 0.255922 19.4407 1.23223 20.4171L17.1421 36.327C18.1184 37.3033 19.7014 37.3033 20.6777 36.327C21.654 35.3507 21.654 33.7677 20.6777 32.7914L6.53553 18.6493L20.6777 4.50716C21.654 3.53085 21.654 1.94793 20.6777 0.971622C19.7014 -0.00468827 18.1184 -0.00468827 17.1421 0.971622L1.23223 16.8815ZM5 16.1493H3L3 21.1493H5V16.1493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.5956d2c1b1caec21f913f7605f2db61c.svg";
export { ForwardRef as ReactComponent };